var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.75,
    height: 14,
    viewBox: "0 0 15.75 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "link",
    d: "M5.359-2a.281.281,0,0,1,0-.465l8.832-8.832-.027-.027H11.7a.316.316,0,0,1-.232-.1.316.316,0,0,1-.1-.232v-.273a.316.316,0,0,1,.1-.232.316.316,0,0,1,.232-.1h3.719a.29.29,0,0,1,.328.328V-8.2a.316.316,0,0,1-.1.232.316.316,0,0,1-.232.1h-.273a.316.316,0,0,1-.232-.1.316.316,0,0,1-.1-.232v-2.461l-.027-.027L5.961-1.859a.281.281,0,0,1-.465,0ZM11.7-6.262a.292.292,0,0,1,.342-.055.3.3,0,0,1,.205.3V.438a1.266,1.266,0,0,1-.383.93,1.266,1.266,0,0,1-.93.383H1.313a1.266,1.266,0,0,1-.93-.383A1.266,1.266,0,0,1,0,.438V-9.187a1.266,1.266,0,0,1,.383-.93,1.266,1.266,0,0,1,.93-.383h9.516a.3.3,0,0,1,.3.205.274.274,0,0,1-.082.342l-.219.219a.26.26,0,0,1-.219.109h-9.3A.426.426,0,0,0,1-9.5a.426.426,0,0,0-.123.314V.438a.421.421,0,0,0,.438.438h9.625a.421.421,0,0,0,.438-.437V-5.8a.34.34,0,0,1,.109-.246Z",
    transform: "translate(0 12.25)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.7f8681ce8e0bba851cce521dfc6e7468.svg";
export { ForwardRef as ReactComponent };